import { Component, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'app-rule-type',
    templateUrl: './rule-type.component.html',
    styleUrls: ['./rule-type.component.scss'],
    imports: [FormlyModule]
})
export class RuleTypeComponent extends FieldType {
}
